<script setup lang="ts">
import { computed } from 'vue';
import { useAppTheme } from '@/composables/useAppTheme';

const { isDark, toggleTheme } = useAppTheme();

const tooltip = computed(() =>
    isDark.value ? 'Светлая тема' : 'Тёмная тема',
);
</script>

<template>
  <v-btn
      class="flex-shrink-0"
      icon
      variant="text"
      density="comfortable"
      v-tooltip="{ text: tooltip, eager: false }"
      aria-label="Переключить тему оформления"
      @click="toggleTheme"
  >
    <v-icon>{{ isDark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
  </v-btn>
</template>
